// Automatically generated during build - DO NOT EDIT MANUALLY
export const APP_VERSION = {
  "version": "1.0.0",
  "buildCode": "20261105.1824",
  "buildDate": "05-Nov-2026 06:24 PM",
  "gitCommit": "eb3c32c",
  "gitBranch": "master",
  "timestamp": 1793883282826,
  "appName": "OxyLoans Web"
};

export default APP_VERSION;
